import { Map } from 'lucide-react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { EmptyState, EmptyStateIconBox, EmptyStateText } from '../../styles';

// Displays an empty state card when no traceroute has been initiated
export function EmptyStateCard() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <EmptyState>
      <EmptyStateIconBox>
        <Map size={36} color={theme.palette.grey['02']} />
      </EmptyStateIconBox>
      <EmptyStateText variant="body1">
        {t('tools.traceroute.emptyState')}
      </EmptyStateText>
    </EmptyState>
  );
}

export default EmptyStateCard;
